module.exports = __webpack_public_path__ + "static/media/Chloe Markley.2ac59e5c.png";